import { Link } from "react-router-dom";
import { Shield, FileText } from "lucide-react";

export default function AppFooter() {
  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400 dark:text-gray-500">
            &copy; {new Date().getFullYear()} Grow Sport Psychology & Mental Performance Improvement. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="inline-flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors"
            >
              <Shield className="w-3 h-3" />
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="inline-flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors"
            >
              <FileText className="w-3 h-3" />
              Terms of Service
            </Link>
            <a
              href="mailto:sports@growwellnessgroup.com"
              className="text-xs text-gray-500 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
